/* Complete the Set discount guard.
   Applies the CTS discount codes only while the Revive Duo is in the bag,
   and removes them as soon as the Duo leaves, so add-ons go back to full price.
   Mirrors wash-day-bundle-guard.js and never touches other discount codes. */
(function () {
  'use strict';
  if (window.__ctsDiscountGuard) return;
  window.__ctsDiscountGuard = true;

  var DUO = 50646922756425;
  var OIL = 55605034090825;
  var ROLLER = 55605034189129;
  var GUIDE = 55605034352969;
  var BRUSH = 55626818814281;
  var CODES = { oil: 'CTS-OIL', roller: 'CTS-ROLLER', guide: 'CTS-GUIDE', brush: 'CTS-BRUSH', all: 'CTS-ALL', all5: 'CTS-ALL5', setOil: 'CTS-SET-OIL', setKit: 'CTS-SET-KIT', setKit3: 'CTS-SET-KIT3' };
  var ALL_CODES = [CODES.oil, CODES.roller, CODES.guide, CODES.brush, CODES.all, CODES.all5, CODES.setOil, CODES.setKit, CODES.setKit3];

  var baseFetch = window.fetch.bind(window);
  var syncing = false;
  var timer = null;
  var recheckTimer = null;

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function norm(code) { return String(code || '').trim().toUpperCase(); }
  function isCts(code) { return ALL_CODES.indexOf(norm(code)) !== -1; }

  function getCart() {
    return baseFetch(shopRoot() + 'cart.js', {
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
  }

  function appliedCodes(cart) {
    var found = {};
    (cart.discount_codes || []).forEach(function (d) { if (d && d.code) found[norm(d.code)] = d.code; });
    function inspect(app) {
      if (!app) return;
      if (String(app.type || '').toLowerCase() === 'discount_code' && app.title) found[norm(app.title)] = app.title;
    }
    (cart.cart_level_discount_applications || []).forEach(inspect);
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (a) {
        inspect(a && (a.discount_application || a.discountApplication));
      });
    });
    return Object.keys(found).map(function (k) { return found[k]; });
  }

  function wantedCodes(cart) {
    var has = {};
    (cart.items || []).forEach(function (item) {
      if (item.quantity > 0) has[Number(item.variant_id)] = true;
    });
    if (!has[DUO]) return [];
    if (has[OIL] && has[ROLLER] && has[GUIDE] && has[BRUSH]) return [CODES.setOil, CODES.setKit, CODES.brush, CODES.guide];
    if (has[OIL] && has[ROLLER] && has[GUIDE]) return [CODES.setOil, CODES.setKit3, CODES.guide];
    var out = [];
    if (has[OIL]) out.push(CODES.oil);
    if (has[ROLLER]) out.push(CODES.roller);
    if (has[GUIDE]) out.push(CODES.guide);
    if (has[BRUSH]) out.push(CODES.brush);
    return out;
  }

  function sameSet(a, b) {
    var x = a.map(norm).sort().join(',');
    var y = b.map(norm).sort().join(',');
    return x === y;
  }

  function openRenderer() {
    var el = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!el) return null;
    var open = el.classList.contains('active') || el.hasAttribute('open') ||
      el.getAttribute('aria-hidden') === 'false' || !!el.querySelector('details[open]');
    return open ? el : null;
  }

  function isCartPage() {
    var path = String(window.location.pathname || '');
    return path === '/cart' || path === shopRoot().replace(/\/$/, '') + '/cart';
  }

  function update(codes, cartBefore) {
    var renderer = openRenderer();
    var sections = renderer && typeof renderer.getSectionsToRender === 'function'
      ? renderer.getSectionsToRender().map(function (s) { return s && s.id; }).filter(Boolean) : [];
    var body = { discount: codes.join(',') };
    if (sections.length) { body.sections = sections; body.sections_url = window.location.pathname + window.location.search; }
    return baseFetch(shopRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (renderer && data && data.sections && typeof renderer.renderContents === 'function') {
        if (!data.id) {
          var first = (cartBefore && cartBefore.items && cartBefore.items[0]) || (data.items && data.items[0]);
          if (first) data.id = first.id || first.variant_id;
        }
        try { renderer.renderContents(data); } catch (e) { console.error('[Complete the set guard]', e); }
      } else if (isCartPage()) {
        window.setTimeout(function () { window.location.reload(); }, 40);
      }
      window.dispatchEvent(new CustomEvent('cts:discounts-updated', { detail: { codes: codes.slice() } }));
      return data;
    });
  }

  function validate() {
    if (syncing) { schedule(250); return; }
    if (window.__washDayBundleBusy) { schedule(250); return; }
    syncing = true;
    getCart().then(function (cart) {
      var applied = appliedCodes(cart);
      var currentCts = applied.filter(isCts);
      var others = applied.filter(function (c) { return !isCts(c); });
      var wanted = wantedCodes(cart);
      if (sameSet(currentCts, wanted)) return null;
      return update(others.concat(wanted), cart);
    }).catch(function (e) {
      console.error('[Complete the set guard]', e);
    }).then(function () {
      syncing = false;
    });
  }

  function schedule(delay) {
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(function () { timer = null; validate(); }, typeof delay === 'number' ? delay : 200);
    /* Second check catches any update another script made at the same moment. */
    if (recheckTimer) window.clearTimeout(recheckTimer);
    recheckTimer = window.setTimeout(function () { recheckTimer = null; validate(); }, 1500);
  }

  function isCartMutation(input, init) {
    try {
      var raw = typeof input === 'string' ? input : (input && input.url) || '';
      if (!raw) return false;
      var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (method === 'GET') return false;
      var url = new URL(raw, window.location.origin);
      return /\/cart\/(?:add|change|update|clear)(?:\.js)?$/.test(url.pathname);
    } catch (e) { return false; }
  }

  var wrapped = window.fetch;
  window.fetch = function (input, init) {
    return wrapped.apply(this, arguments).then(function (response) {
      if (isCartMutation(input, init) && !syncing) schedule(200);
      return response;
    });
  };

  window.addEventListener('washday:discounts-updated', function () { schedule(300); });
  window.addEventListener('washday:cart-changed', function () { schedule(300); });
  window.addEventListener('pageshow', function () { schedule(100); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { schedule(100); }, { once: true });
  } else {
    schedule(100);
  }
})();
